import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { browserHistory } from 'react-router';
import makeRoutes from './Routes';
import 'babel-polyfill';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';

const routes = makeRoutes();
ReactDOM.render(
        <App history={browserHistory} routes={routes} />
    , document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js